import appConfig from '../appConfig';
import {config} from '../config';

export default {
    getIsManualRegistrationEnabled: () => config.data.manualRegistration.isManualRegistrationEnabled,
    getManualRegistrationImagePath: (devicePlatform) => {
        const manualRegistrationImagePath =
            config.data.manualRegistration.manualRegistrationImages[devicePlatform]?.manualRegistrationImagePath;

        return appConfig.getCombinedPathAssetPath(manualRegistrationImagePath);
    },
};
